import {
  ArrowDownCircleIcon,
  ArrowsPointingInIcon,
  LockClosedIcon,
} from "@heroicons/react/24/outline";
import { useTranslate } from "@tolgee/react";

const features = [
  {
    name: "CrMo 4130 steel",
    description:
      "Butted tubing, spiral tubing, plain gauge tubing, bicycle tubing and go-kart tubing",
    icon: ArrowsPointingInIcon,
  },
  {
    name: "Aluminum tubes",
    description:
      "Tube Hydroforming, shaped tubes, extruded shaped tubes. Seamless or welded AL5068, AL6061, AL7005",
    icon: LockClosedIcon,
  },
  {
    name: "Handlebars",
    description:
      "Aero shaped hydroforming handlebars, hydroforming MTB handlebars. AL6061, AL7050, AL7075",
    icon: ArrowDownCircleIcon,
  },
];

export default function Offer() {
  const { t } = useTranslate();
  return (
    <div className="bg-white py-16 lg:pt-24 lg:pb-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            {t("offer-title")}
          </h2>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-full">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-16">
                <dt className="text-lg font-semibold leading-7 text-gray-900">
                  <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-slate-600">
                    <feature.icon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-2 text-lg leading-7 text-slate-600">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
